import { Component, Input } from '@angular/core';
import { Tab } from '../models/tab';

@Component({
  selector: 'vrc-tab',
  templateUrl: './vrc-tab.component.html',
  styleUrls: ['./vrc-tab.component.scss']
})
export class VrcTabComponent implements Tab {
  @Input() label!: string;
  @Input() active = false;
  @Input() styleButton = '';
}

